import { Dropdown } from "Common/Components/Dropdown";
import { Eye, FileEdit, MoreHorizontal, Trash2 } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { Order } from "../../../types/order.types";

interface OrderActionsProps {
  order: Order;
  rowIndex: number;
  onDelete: (order: Order) => void;
}

export const OrderActions: React.FC<OrderActionsProps> = ({ order, rowIndex, onDelete }) => {
  return (
    <div className="relative">
      <Dropdown className="static">
        <Dropdown.Trigger
          id={`orderAction${order.id}`}
          data-bs-toggle="dropdown"
          className="flex items-center justify-center size-[30px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20"
        >
          <MoreHorizontal className="size-3" />
        </Dropdown.Trigger>
        <Dropdown.Content
          placement={rowIndex < 3 ? "start-end" : "top-start"}
          className="absolute z-[9999] py-2 mt-1 list-none bg-white rounded-md shadow-lg min-w-[10rem] dark:bg-zink-600 border border-slate-200 dark:border-zink-500"
          aria-labelledby={`orderAction${order.id}`}
        >
          <li>
            <Link
              to={`/sale-orders/view/${order.id}`}
              className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
            >
              <Eye className="inline-block size-3 ltr:mr-1 rtl:ml-1" />{" "}
              <span className="align-middle">Visualizar</span>
            </Link>
          </li>
          {order.status !== 2 && (
            <li>
              <Link
                to={`/sale-orders/edit/${order.id}`}
                className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
              >
                <FileEdit className="inline-block size-3 ltr:mr-1 rtl:ml-1" />{" "}
                <span className="align-middle">Editar</span>
              </Link>
            </li>
          )}
          {order.status !== 2 && (
            <li>
              <button
                type="button"
                className="w-full text-left block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200"
                onClick={() => onDelete(order)}
              >
                <Trash2 className="inline-block size-3 ltr:mr-1 rtl:ml-1" />{" "}
                <span className="align-middle">Excluir</span>
              </button>
            </li>
          )}
        </Dropdown.Content>
      </Dropdown>
    </div>
  );
};
